export const buildStatsCards = (stats, t, locale, labels, typesForfaits) => {
  const activite = [
    { label: t("ActiveGroups"), value: stats.totalGroupes, icon: "📦" },
    { label: t("Organizer"), value: stats.totalUtilisateurs, icon: "🧑‍💼" },
    { label: t("Contacts"), value: stats.totalContacts, icon: "👥" },
    { label: t("TotalQuantityItems"), value: stats.totalQuantiteItems, icon: "🧺" }
  ];

  const forfaits = [
    { label: t("FreeGroupsInactives"), value: stats.totalGroupesGratuitsSimples, icon: "🎁" },
    { label: t("FreeGroupsActives"), value: stats.totalGroupesGratuitsActifs, icon: "✅" },
    { label: t("GroupDelDashboard"), value: stats.totalGroupesSupprimes, icon: "❌" },
    ...(typesForfaits || [])
      .filter(type => type !== "gratuit") // on ne boucle que sur les payants
      .map(type => ({
        label: labels?.[type]?.[locale] || type,
        value: stats.forfaitsActifs?.[type] ?? 0,
        icon: "📅"
      }))
  ];

  return { activite, forfaits };
};
